// extracted by mini-css-extract-plugin
export default {"cta":"HH-z","disabled":"IH-z"};